import { render, staticRenderFns } from "./WebHostingDatabase.vue?vue&type=template&id=65e7fe21&scoped=true&"
import script from "./WebHostingDatabase.vue?vue&type=script&lang=js&"
export * from "./WebHostingDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e7fe21",
  null
  
)

export default component.exports